import {
  GetAccessTokenFunc,
  GetUserOrganizationsFunc,
  UserOrganizationType
} from "@digital-services/shell";

import { fetcher } from "@/utils/api/swr-utils";

import { USER_ORGANIZATIONS_PATH } from "./paths";

export default function useGetUserOrganizations(): GetUserOrganizationsFunc {
  const getUserOrganizations = async (
    getAccessToken: GetAccessTokenFunc
  ): Promise<Array<UserOrganizationType>> => {
    if (!getAccessToken) {
      throw new Error(
        "Authentication is not initialized or access token is unavailable"
      );
    }
    const response = await fetcher(USER_ORGANIZATIONS_PATH, getAccessToken);

    return response.organizations;
  };

  return getUserOrganizations;
}
